import {
  ENERGY_MACHINES_ORGANIZATION_ID,
  SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID
} from "@/lib/white-label-branding/BrandLabelConstants";
import { useAuth0 } from "@auth0/auth0-react";
import { createFileRoute } from "@tanstack/react-router";

type InvitationSearch = {
  organization: string; // The organization ID from Auth0 - if the user is sent to the login page with search params it is an invitation and this field will be populated with the ID.
  invitation: string;
};

export const Route = createFileRoute("/invitation")({
  component: Invitation,
  validateSearch: (search: Record<string, unknown>): InvitationSearch => {
    return {
      organization: (search.organization as string) || "",
      invitation: (search.invitation as string) || ""
    };
  }
});

function Invitation() {
  const { organization, invitation } = Route.useSearch();

  const { loginWithRedirect } = useAuth0();

  if (organization === ENERGY_MACHINES_ORGANIZATION_ID && invitation) {
    loginWithRedirect({
      authorizationParams: {
        invitation,
        organization
      }
    });
  }

  if (organization === SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID && invitation) {
    loginWithRedirect({
      authorizationParams: {
        invitation,
        organization
      }
    });
  }
}
